var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinalStatus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99996 12C4.81327 12 3.65365 11.6475 2.66696 10.9882C1.68026 10.329 0.91112 9.39319 0.456994 8.29684C0.00286847 7.20048 -0.116314 5.99393 0.115197 4.83004C0.346709 3.66615 0.91866 2.59689 1.75778 1.75778C2.59689 0.91866 3.66518 0.346709 4.82906 0.115197C5.99295 -0.116314 7.1995 0.00286847 8.29586 0.456994C9.39222 0.91112 10.3299 1.67928 10.9892 2.66598C11.6485 3.65267 12 4.81327 12 5.99996C11.9973 7.59045 11.3639 9.11555 10.2392 10.2402C9.11458 11.3648 7.59045 11.9973 5.99996 12ZM3.31442 5.42184L2.63668 6.09762L5.03707 8.49801L9.35836 4.17574L8.67672 3.49996L5.0361 7.14059L3.30953 5.41988L3.31442 5.42184Z",
    fill: "#378A05"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalStatus);
export default __webpack_public_path__ + "static/media/Final-Status.9af05ac27fd3b0f0c5a517ec6f9b53c6.svg";
export { ForwardRef as ReactComponent };